import * as PropTypes from "prop-types"
import styled from "styled-components"
import Image from "next/legacy/image"
import Typography from "components/styled/Typography"

const Col = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 125px;
  text-align: center;

  small {
    line-height: 14px;
  }
`

const ImageWrapper = styled.div`
  background: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 0 auto 5px;
  padding: 9px;
`

const Content = styled.div`
  display: flex;
  align-items: center;
  min-height: 50px;
`

function Item({ icon, children }) {
  return (
    <Col>
      <ImageWrapper>
        <Image alt={icon} src={`/f_svg/static/services/${icon}`} width="32" height="32" layout="fixed" />
      </ImageWrapper>
      <Content>
        <Typography variant="small">{children}</Typography>
      </Content>
    </Col>
  )
}

Item.propTypes = {
  icon: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default Item
